
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppCoachResourcesSupplementsListFormRemove} from "@/models/app/coach/resources/supplements/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "supplement",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppCoachResourcesSupplementsListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  supplement: AppCoachResourcesSupplementsListFormRemove = new AppCoachResourcesSupplementsListFormRemove();

  formData: AppCoachResourcesSupplementsListFormRemove = new AppCoachResourcesSupplementsListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/administration/supplement/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getSupplements');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.supplement;
  }

  resetFormData(): void {
    this.formData = new AppCoachResourcesSupplementsListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
